<nav
  *ngIf="breadcrumbs && breadcrumbs.length"
  aria-label="breadcrumb"
  class="flex items-center text-[24px]"
>
  <button
    *ngIf="breadcrumbs.length > 1"
    (click)="goBack()"
    class="mr-4 p-1 cursor-pointer"
    aria-label="Go back"
  >
    <i class="fa-solid fa-chevron-left"></i>
  </button>
  <ol class="flex flex-wrap items-center gap-x-2 gap-y-1">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last" class="flex items-center min-w-0">
      <a
        *ngIf="!last"
        [routerLink]="breadcrumb.url"
        class="hidden md:inline-block text-caption_light font-bold hover:text-basic transition-colors duration-200 break-words"
      >
        {{ breadcrumb.label | translate }}
      </a>
      <span *ngIf="last" class="text-primary font-bold break-words" aria-current="page">
        {{ breadcrumb.label | translate }}
      </span>
      <!--
      <svg
        *ngIf="!last"
        class="h-7 w-7 text-caption_light mx-2"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        ></path>
      </svg>-->
    </li>
  </ol>
</nav>
